<template>
    <a-layout class="layout">

        <!-- 侧边 -->
        <a-layout-sider class="menu-left" width="270" :trigger="null">
            <LayoutLogo style="width:220px"/>
            <a-menu
              mode="inline"
              style="width:220px"
              v-model:selectedKeys="selectedKeys"
              v-model:openKeys="openKeys"
              triggerSubMenuAction="click"
            >
                <LayoutMenus v-for="(item,index) in menus" :key="index" :item="item"  />
            </a-menu>
        </a-layout-sider>

        <a-layout>

            <!-- 头部 -->
            <a-layout-header class="header">
              <LayoutHeader v-model:collapsed="collapsed"/>
            </a-layout-header>
            

            <!-- 内容 -->
            <a-layout-content class="contentBox">
              <LayoutTabs />
            </a-layout-content>

            <!-- 底部 -->
            <!-- <a-layout-footer class="footerBox">
              <LayoutFooter/>
            </a-layout-footer> -->
            

        </a-layout>

    </a-layout>
</template>
<script>
import { defineComponent, ref, watch, onBeforeMount, onMounted, onUnmounted } from "vue"
import { useRoute, useRouter} from 'vue-router'
import LayoutMenus from './menu/index.vue'
import LayoutTabs from './content/index.vue'
import LayoutHeader from './header/index.vue'
import LayoutLogo from './logo/index.vue'
import LayoutFooter from './Footer/index.vue'
// import aIcon from '@/components/aicon/index.vue'
export default defineComponent({
    name: 'layout',
    components: {
        LayoutMenus,
        LayoutHeader,
        LayoutTabs,
        LayoutLogo,
        LayoutFooter
    },
    setup() {
        const route = useRoute()
        const menus = useRouter().options.routes
        const collapsed = ref(false)
        const selectedKeys = ref([''])
        const openKeys = ref([''])
        const setMenuKey = () => {
            // route.matched[0].children.length >= 1
            //   ? selectedKeys.value = [route.path]
            //   : selectedKeys.value = [route.matched[0].path]
            route.matched[0].meta.isRouteBool 
              ? selectedKeys.value = [route.path]
              : selectedKeys.value = [route.matched[0].path]
            openKeys.value = [route.matched[0].path]
        }
        onBeforeMount(setMenuKey)
        //注释掉，否则跳转详情菜单不会选中
        watch(route, setMenuKey)

        return { collapsed, menus, selectedKeys, openKeys, }
    }
})
</script>
<style lang="less" scoped>
.ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content{
  width: calc(1400px - 270px);
  max-width: calc(1400px - 270px);
  min-width: calc(1400px - 270px);
  padding: 0 32px;
  margin: 0 auto;
}
.logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.3);
  margin: 16px;
}
.layout {
  // overflow: hidden;
  min-height: 100vh;
  & .header {
    background-color: #FFF;
    padding: 0;
  }
  & .contentBox{
    margin: 30px 0;
  }
  & .footerBox{
    padding: 0;
    margin: 30px 0;
  }
  & .container {
    padding: 8px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  & .container::-webkit-scrollbar {
    width: 6px;
  }
  & .container::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px #d8d8d8;
    background: #C1C1C1;
  }
  & .container::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #d8d8d8;
    background: #ededed;
  }
}
.ant-layout-header{
    height: 60px;
    margin: 30px 0;
    border-radius: 10px;
}

</style>
<style lang="less">
.layout {
  & .ant-layout-sider-children {
    overflow-y: auto;
    overflow-x: hidden;
    position: fixed;
  }
  & .ant-layout-sider-children::-webkit-scrollbar {
    width: 4px;
  }
  & .ant-layout-sider-children::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px #d8d8d8;
    background: #535353;
  }
  & .ant-layout-sider-children::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #d8d8d8;
    background: #ededed;
  }
}
</style>